import React from 'react'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import ControlledSelectField from '../../../../../../../../../forms/select-field/ControlledSelectField'
import { getVatRateOptions } from '../../../../../../../shared/utils/house-options.utils'
import { HouseNightlyTripIndividualFieldProps } from '../../../form-container/HouseNightlyTripIndividualFormContainer'

export const HouseNightlyTripIndividualVatField = ({
  control,
  isFieldDisabled,
  currencyArea,
}: HouseNightlyTripIndividualFieldProps) => {
  const intl = useIntl()
  return (
    <div className={s.vatRate}>
      <ControlledSelectField
        control={control}
        rules={{ required: 'Champ requis.' }}
        name='options.vatRate'
        labelClassName={s.vatRateLabel}
        inline={true}
        menuPlacement='top'
        label={intl.formatMessage({
          defaultMessage: 'TVA applicable aux nuitées',
          id: 'ui.HouseNightlyTripIndividualVatField.label.nights',
        })}
        options={getVatRateOptions(currencyArea.vatRates)}
        disabled={isFieldDisabled}
        placeholder={intl.formatNumber(0, {
          style: 'percent',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      />
    </div>
  )
}
